let ColorPalette = {
  light: {
    background: {
      default: "#F1F1F1", // Change the background color for dark mode
    },
    primary: {
      main: "#00A1A1",
      light: "#D8F4F5",
      contrastText: "#fff",
    },
    secondary: {
      main: "#770332",
      light: "#FDF2F8",
      contrastText: "#fff",
    },
    success: {
      main: "#69CB1C",
      light: "#F0FAE8",
      contrastText: "#fff",
    },
    info: {
      main: "#5780FF",
      light: "#EEF2FF",
      contrastText: "#fff",
    },
    warning: {
      main: "#FFC700",
      light: "#FFF9E6",
      contrastText: "#fff",
    },
    error: {
      main: "#FF3938",
      light: "#FFEBEB",
      contrastText: "#fff",
    },
    text: {
      main: "#222222",
      light: "#555555",
      fade: "#BBBBBB",
      contrastText: "#fff",
    },
    border: {
      main: "#e5e5e5",
    },
    paper: "#fff",
  },
  dark: {
    background: {
      default: "#111", // Change the background color for dark mode
    },
    primary: {
      main: "#00A1A1",
      light: "#016363",
      contrastText: "#fff",
    },
    secondary: {
      main: "#BE185D",
      light: "#130209",
      contrastText: "#fff",
    },
    success: {
      main: "#69CB1C",
      light: "#132603",
      contrastText: "#fff",
    },
    info: {
      main: "#5780FF",
      light: "#050E28",
      contrastText: "#fff",
    },
    warning: {
      main: "#FFC700",
      light: "#271F02",
      contrastText: "#fff",
    },
    error: {
      main: "#FF3938",
      light: "#370C0C",
      contrastText: "#fff",
    },
    text: {
      main: "#DEDEDE",
      light: "#BBBBBB",
      fade: "#555555",
      contrastText: "#fff",
    },
    border: {
      main: "#333333",
    },
    paper: "#171717",
  },
};
export default ColorPalette;
